import { z } from 'zod'

export const assetsSearchSchema = z.object({
  view: z.enum(['grid', 'list']).optional().catch(undefined),
  /** Short id of the open folder; absent = the root. */
  folder: z.string().optional().catch(undefined),
  q: z.string().optional().catch(undefined),
  /** Only items a given member uploaded or created; absent = anyone. */
  authorId: z.uuid().optional().catch(undefined),
  /** Which root is open when no folder is; absent = the workspace's own. */
  space: z.enum(['workspace', 'org']).optional().catch(undefined),
})

export type AssetsSearchParams = z.infer<typeof assetsSearchSchema>
